<template>
  <div class="cash-withdrawal">
    <div class="tixian">
      <div class="jiangli_top" @click="$router.go(-1)">
        <img src="../../assets/images/baifan.png" />
        <p class="bt">{{ $t("m.jy_span5") }}</p>
      </div>
      <!-- <div class="tixian_price" style="padding-left:25px;margin-top:30px;">
        <p class="trips"> {{xuan==0?$t('m.ct_span01'):$t('m.ct_span02')}}</p>
        <p v-if="xuan==0" class="tixian_price_num"><span style="font-size:14px;"></span>{{ ktxje }}</p>
        <p v-if="xuan==1" class="tixian_price_num"><span style="font-size:14px;"></span>{{ ktxje1 }}</p>

      </div> -->
    </div>
    <div class="tixian_block">
      <div
        class="tixian_block_card"
        style="display:flex;align-items:center;margin-top:20px;"
        @click="backShow1(0)"
      >
        <img style="width: 20px;" src="../../assets/images/new/yinlian.png" />
        <div class="tixian_block_card-flex">
          <p class="" style="font-size: 14px;color: #444;white-space: nowrap;">
            {{ $t("m.ct_span8") }}
          </p>
          <p class="" style="font-size: 14px;color: #999;margin-top: 0px;"></p>
        </div>
        <!-- <img style="width: 20px;" src="../../assets/images/licai/right.png" /> -->
        <img style="width: 20px;" :src="xuan == 0 ? img1 : img2" />
      </div>
      <div
        class="tixian_block_card"
        style="margin-top:30px; display:flex:align-items:center;"
        @click="backShow1(1)"
      >
        <img style="width: 20px;" src="../../assets/images/new/USDT.png" />
        <div class="tixian_block_card-flex">
          <p class="" style="font-size: 14px;color: #444;white-space: nowrap;">
            {{ $t("m.ct_span9") }}
          </p>
          <p class="" style="font-size: 14px;color: #999;margin-top: 0px;"></p>
        </div>
        <!-- <img style="width: 20px;" src="../../assets/images/licai/right.png" /> -->
        <img style="width: 20px;" :src="xuan == 1 ? img1 : img2" />
      </div>
      <p
        class=""
        style="margin-top: 30px;font-size:15px;font-weight:bold;color:#666;"
      >
        {{ $t("m.ct_span01") }}
      </p>
      <div class="tixian_shuru">
        <p class="" style="font-size:16px;width: 80px;">
          {{ $t("m.tz_span4") }}
        </p>
        <input
          readonly="readonly"
          @click="show = true"
          v-model="money"
          autocomplete="off"
          class="tixian_input"
          :placeholder="$t('m.ct_span21')"
        />
        <span
          @click="quanbu(ktxje)"
          style="width: 100px;text-align:right;font-size:12px;color:#888;position: relative;top:4px;"
          >{{ $t("m.ct_span04") }}</span
        >
        <van-number-keyboard
          :show="show"
          theme="custom"
          extra-key="."
          :close-button-text="$t('m.finish')"
          @blur="show = false"
          @input="onInput"
          @delete="onDelete"
        />
      </div>
      <div
        class="tixian_trip"
        style="display: flex;justify-content: space-between;color: #9e9797;"
      >
        <p>{{ $t("m.ct_span10") }} {{ ktxje }}</p>
        <p>{{ $t("m.ct_span1c") }} {{ ktxje1 }}</p>
      </div>

      <div class="">
        提现申请成功后，请耐心等待，若许久未到账请联系客服。
      </div>
      <!-- <div class="tixian_block_card" style="display:flex:align-items:center;" @click="backShow = true">
        <img style="width: 30px;" src="../../assets/images/new/yinlian.png" />
        <div class="tixian_block_card-flex">
          <p
            class=""
            style="font-size: 16px;color: #444;white-space: nowrap;"
            v-if="currentBack"
          >
            {{ currentBack.type }} （{{
              "****" + currentBack.card.substring(currentBack.card.length - 6)
            }}）
          </p>
          <p class="" style="font-size: 14px;color: #999;margin-top: 0px;"></p>
        </div>
        <img style="width: 20px;" src="../../assets/images/licai/right.png" />
      </div> -->
    </div>
    <div
      v-if="xuan == 1"
      class="tixian_buts"
      @click="
        backList.length > 0 ? backShowqqq() : $router.push({ name: 'bank_add' })
      "
    >
      <button>{{ $t("m.tijiao") }}</button>
    </div>
    <div
      v-if="xuan == 0"
      class="tixian_buts"
      @click="
        backList.length > 0 ? backShowqqq() : $router.push({ name: 'bank_add' })
      "
    >
      <button>{{ $t("m.tijiao") }}</button>
    </div>
    <van-popup
      v-model="backShow"
      position="bottom"
      :style="{ height: '55%', paddingTop: '10px', padding: '20px' }"
    >
      <div class="zfmm title">请选择银行卡</div>
      <div v-if="backList.length > 0">
        <div
          v-if="(xuan == 0 && item.type == 1) || (xuan == 1 && item.type == 2)"
          class="tixian_block_card carditem"
          style="height: 40px;"
          v-for="(item, index) in backList"
          :key="index"
          @click="changeBank(item)"
        >
          <img style="width: 30px;" src="../../assets/images/new/yinlian.png" />

          <div class="" style="margin-left: 8px;">
            <p class="" style="font-size: 16px;color: #666;">
              {{ item.btype }} （{{ item.card }}）
            </p>
          </div>
          <div class="tixian_block_img">
            <img
              style="width: 20px;"
              src="../../assets/images/licai/right.png"
            />
          </div>
        </div>
      </div>
      <div class="tixian_block_card carditem" v-else>
        <div class="">
          <p class="" style="font-size: 20px;color: #000;">绑定银行卡</p>
          <p class="" style="font-size: 14px;color: #999;"></p>
        </div>
        <div class="tixian_block_img">
          <img style="width: 20px;" src="../../assets/images/licai/right.png" />
        </div>
      </div>
    </van-popup>

    <van-dialog
      confirmButtonColor="#4076FA"
      v-model="passwordShow"
      :title="$t('m.yh_span7')"
      show-cancel-button
      @confirm="pwdChange2"
      @cancel="pwd = ''"
      @close="pwd = ''"
    >
      <div class="zfmm">
        <van-field
          v-model="pwd"
          :placeholder="$t('m.ct_span11')"
          type="password"
        />
      </div>
    </van-dialog>
    <div style="height:1.4rem;"></div>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>
<script>
import { postCashInfo, getMyUserInfo } from "../../api/user";

import { bank_list, pay_withdraw } from "@api/pay";
import request from "@utils/request";
export default {
  name: "UserCash",
  components: {},
  props: {},
  data: function() {
    return {
      xuan: 0,
      img1: require("../../assets/images/new/xuanzhong.png"),
      img2: require("../../assets/images/new/weixuanzhong.png"),
      shows: false,
      currentBack: null,
      currentUsdt: null,
      backList: [],
      backShow: false,
      passwordShow: false,
      pwd: "",
      money: "",
      cid: "",
      showKeyboard: true,

      navList: [
        {
          name: "银行卡",
          type: "bank",
          icon: "icon-yinhangqia"
        }
      ],
      miaoshu1: "",
      xuan: 0,
      ktxje: 0,
      ktxje1: 0,
      show: false,
      index: 0,
      currentTab: 0,
      minPrice: 0,
      banks: [],
      commissionCount: 0,
      item: ""
    };
  },
  created() {
    let vm = this;
    setTimeout(() => {
      getMyUserInfo().then(res => {
        console.log(res.data, res.data.data.money);
        vm.ktxje = res.data.data.money;
        vm.ktxje1 = res.data.data.usdt;
      });
    }, 1000);

    bank_list({ page: 1 })
      .then(res => {
        console.log(res);
        vm.backList = res.data.data;
        if (vm.backList.length > 0) {
          for (let i = 0; i < vm.backList.length; i++) {
            const div = vm.backList[i];
            if (div.type == "2") {
              vm.currentUsdt = vm.backList[i];
            } else {
              vm.currentBack = vm.backList[i];
            }
          }
        }

        console.log("bank_list", res);
      })
      .catch(err => {
        console.log("回调", err);
        this.$dialog.error(err.response.data.msg);
        vm.$router.push({ path: "/memmber_business" });
      });
  },
  mounted: function() {
    this.miaoshu1 = this.$t("m.ct_span7");
  },
  methods: {
    quanbu() {
      if (this.xuan == 0) {
        this.money = this.ktxje;
      } else {
        this.money = this.ktxje1;
      }
    },
    backShow1(E) {
      this.xuan = E;
      if (E == 0) {
        this.miaoshu1 = this.$t("m.ct_span7");
      } else {
        this.miaoshu1 = "USDT";
      }
    },
    changeBank(item) {
      let vm = this;
      if (this.xuan == 0) {
        console.log("银行卡");
        console.log(item.btype);
        vm.currentBack = item;
      } else {
        console.log("USDT");
        console.log(item.btype);
        vm.currentUsdt = item;
      }

      vm.backShow = false;
      vm.passwordShow = true;
    },

    pwdDelete() {
      let vm = this;
      vm.pwd = vm.pwd.substr(0, vm.pwd.length - 1);
    },
    backShowqqq() {
      let vm = this;
      if (this.xuan == 0 && !vm.currentBack) {
        vm.$dialog.error("请先绑定银行卡！");
        return;
      }
      if (this.xuan == 1 && !vm.currentUsdt) {
        vm.$dialog.error("请先添加USDT账户！");
        return;
      }
      this.backShow = true;
    },
    pwdChange2() {
      let vm = this;
      if (this.xuan == 0 && !vm.currentBack) {
        vm.$dialog.error("请先绑定银行卡！");
        return;
      }
      if (this.xuan == 1 && !vm.currentUsdt) {
        vm.$dialog.error("请先添加USDT账户！");
        return;
      }

      vm.passwordShow = false;
      vm.shows = true;
      if (this.xuan == 0) {
        pay_withdraw({
          cid: vm.currentBack.id,
          money: vm.money,
          pwd: vm.pwd
        })
          .then(res => {
            vm.shows = false;

            vm.pwd = "";
            console.log(res.data.msg);
            this.$dialog.success(res.data.msg);
            this.$router.push({
              path: "/withdrawal_record"
            });
          })
          .catch(err => {
            vm.shows = false;
            vm.$dialog.error(err.response.data.msg);
          });
      } else {
        let dic = {
          cid: vm.currentUsdt.id,
          money: vm.money,
          pwd: vm.pwd
        };
        request
          .post("/pay/us/withdrawal_record", dic, { login: true })
          .then(res => {
            vm.shows = false;
            vm.pwd = "";
            this.$dialog.success(res.data.msg);
            this.$router.push({
              path: "/withdrawal_record"
            });
          })
          .catch(err => {
            vm.shows = false;
            this.$dialog.error(err.response.data.msg);
          });
      }
    },
    pwdChange(val) {
      let vm = this;
      vm.pwd += val;
    },

    onInput(value) {
      let vm = this;
      this.money = vm.money + value;
    },
    onDelete() {
      console.log("sdsdsa");
      this.money = this.money.slice(0, this.money.length - 1);
    },
    submits: function() {
      this.$router.push({ path: "/user/audit" });
    },
    save: function(info) {
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },

        error => {
          this.$dialog.error(error.response.data.msg);
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.bt {
  color: white !important;
}

/deep/.zfmm {
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  color: #333333;
  padding-left: 20px;
  padding-right: 20px;

  .van-field {
    background-color: #f1f1f3;
    background-color: #f1f1f3;
  }
}

.title {
  padding: 10px;

  width: 100%;
  text-align: center;
  color: #333333;
}

.carditem {
  margin-top: 15px;
}

// /deep/.van-popup--bottom{
//     background: #F2F3F5;
// }
</style>
<style type="text/css">
.tixian_buts {
  width: 92%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

.tixian_buts button {
  color: #ffffff;
}

.tixian_trip {
  display: flex;
  align-items: center;
  color: #ff6241;
}

.tixian_input {
  font-size: 16px;
  width: 70%;
  padding-left: 10px;
}

.tixian_trip {
  margin-top: 20px;
}

.tixian_block {
  width: 92%;
  margin: 0 auto;
  border-radius: 10px;
  margin-top: -30px !important;
  background-color: #fff;
  padding: 1px 15px 10px 15px;
}

.tixian_block_img {
  margin-left: auto;
}

.tixian_block_card {
  display: flex;
  align-items: center;
  margin: 14px 0px;
}

.tixian_block_card-flex {
  flex: 1;
  padding-left: 10px;
}

.tixian_shuru {
  display: flex;
  align-items: center;
  margin-top: 15px;
  padding: 15px 0px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dfdfdf;
}

.tixian {
  width: 100%;
  height: 80px;
  /* background: linear-gradient(-88deg, #1664FC 0%, #E64839 100%); */
  /* background-image: url( ../../assets/images/new/tiback.png); */
  background-repeat: no-repeat;
  background-size: 100% 200px;
}

.tixian_price_num {
  font-size: 26px;
  font-weight: bold;
  color: #ffffff;

  margin-top: 0px;
}

.trips {
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
}

.jiangli_top {
  width: 100%;
  height: 45px;
  line-height: 45px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.jiangli_top img {
  height: 20px;
  width: 20px;
  position: absolute;
  left: 12px;
}

.jiangli_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333;
  text-align: center;
}
</style>
